import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustBadge } from '../components/TrustBadge';
import { ValueProps } from '../components/ValueProps';
import { ProgramBreakdown } from '../components/ProgramBreakdown';
import { WhyUs } from '../components/WhyUs';
import { CTASection } from '../components/CTASection';
import { LocationSection } from '../components/LocationSection';
import { Footer } from '../components/Footer';
import { StickyMobileCTA } from '../components/StickyMobileCTA';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-red-100 selection:text-red-900" data-id="element-175">
      <Header data-id="element-176" />

      <main data-id="element-177">
        <Hero data-id="element-178" />
        <TrustBadge data-id="element-179" />
        <ValueProps data-id="element-180" />
        <ProgramBreakdown data-id="element-181" />
        <WhyUs data-id="element-182" />
        <CTASection variant="mid" data-id="element-183" />
        <LocationSection data-id="element-184" />
        <CTASection variant="bottom" data-id="element-185" />
      </main>

      <Footer data-id="element-186" />
      <StickyMobileCTA data-id="element-187" />
    </div>;
}